<div class="lcl-dashboard-quote-card">
  <app-lcl-header-detailed-info
    [template]="enumDetailedInfoPlacementEnum.quoteDashboardTemplate"
    [isDashboardPlacement]="true"
    [isQuote]="true"
    [referenceValue]="quote?.referenceNumber"
    [referenceName]="referenceTitleKey"
    [info]="quote"
  ></app-lcl-header-detailed-info>
  <app-lcl-shipment-totals-info [aggregatedStatistics]="quote?.aggregatedStatistics"></app-lcl-shipment-totals-info>
  <app-lcl-quote-total-cost
    [price]="quote?.aggregatedStatistics?.totalPrice"
    [validity]="quote?.voyage?.validityDate"
    (bookQuoteSource)="bookQuote()"
  ></app-lcl-quote-total-cost>
</div>
